// pre defined route names

const routeNames = {
  assortment: "Assortiment",
  application: "Aanvraag",
  outro: "Outro",
};

export default routeNames;
